module.exports = __webpack_public_path__ + "static/akano-14f997677b39f2db9f980ab0fd1177cb.jpg";